<template>
    <div class="modal-content">
        <!-- <div class="modal-header">
            <h3 class="modal-title">{{$t('delete', 'Delete')}}</h3>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&#10006;</button>
        </div> -->

        <div class="modal-body ">
            <div class="delete-content">
                <h3>{{$t('delete-account', 'Delete Account')}}?</h3>
                <p>{{$t('are-you-sure-want-to-delete-this-acoount', 'Are you sure you want to, delete this account?')}}</p>
            </div>
            <div class="header-but  info-footer">
                <button type="button" @click="$emit('close')" class="thm-but thm-bor-but"  data-bs-dismiss="modal" >{{$t('no', 'No')}}</button>
                <a href="javascript:void(0)" class="thm-but" @click="deleteFunctionCall()" data-bs-dismiss="modal">{{$t('yes', 'Yes')}}</a>
            </div>
        </div>
    </div>
 
</template>
<script>
import { removeAccount } from '../services/walletWithdraw'
export default {
    name: "DeleteModal",
    props: ['item'],
    emits: ['close', 'yes-click'],
    methods:{
        deleteFunctionCall() {
            this.deleteServiceCall();
        },
        async deleteServiceCall() {
            // this.$apiCall('post', 'DELETE_ACCOUNT', { "id": this.item.id }, 'wallet' ).then(response => {
            //     this.loading = false;
            //     if (response) {
            //         if (response.status == 200) {
            //             if (response?.data?.status == 0) {
            //                 this.$errorToast(response.data.debug[0])
            //             }
            //             else {
            //                 this.$successToast(response?.data?.message)
            //                 this.$emit('yes-click');
            //                 this.$refs.close_btn.click();
            //             }
            //         }
            //     }
            // }).catch(error => {
            //     this.loading = false;
            //     if (error) {
            //         this.$errorToast(error[0]);
            //     }
            // });
            console.log(this.item);
            
            let response = await removeAccount(this.item.client_account_id)
            if(response) {
                this.$emit('yes-click');
            }
        },
    },
};
</script>